<template>
    <Disclosure v-slot="{ open }" as="nav" class="border-b border-gray-200" :style="{ backgroundColor: '#F8E9E2' }">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex justify-between h-16">
                <div class="flex">
                    <Menu as="div" class="relative" style="align-items: center; margin-top: 17px;">
                        <div>
                            <MenuButton class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <span class="sr-only">Open user menu</span>
                                <svg
                                    class="h-8 w-8 text-gray-700"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  >
                                    <line x1="4" y1="7" x2="20" y2="7" />
                                    <line x1="4" y1="12" x2="20" y2="12" />
                                    <line x1="4" y1="17" x2="20" y2="17" />
                                  </svg>
                            </MenuButton>
                        </div>
                        <transition enter-active-class="transition ease-out duration-200" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                            <MenuItems class="origin-top-left absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" style="left: 0px;">
                                <MenuItem v-for="item in userNavigation" :key="item.name" v-slot="{ active }">
                                    <a :href="item.href" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">
                                        {{ item.name }}
                                    </a>
                                </MenuItem>
                            </MenuItems>
                        </transition>
                    </Menu>
                    <div class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                        <template v-for="item in navigation" :key="item.name">
                            <Menu v-if="item.children && item.children.length" as="div" class="relative">
                                <MenuButton :class="[ 'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-bold', 'border-transparent text-black hover:border-gray-300 hover:text-black']">
                                    {{ item.name }}
                                </MenuButton>
                                <transition enter-active-class="transition ease-out duration-200" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                    <MenuItems class="origin-top-left absolute left-0 mt-2 w-56 z-50 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <MenuItem v-for="child in item.children" :key="child.name" v-slot="{ active }">
                                            <a :href="child.href" :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm', child.current ? 'font-bold text-black' : 'text-gray-700']">
                                                {{ child.name }}
                                            </a>
                                        </MenuItem>
                                    </MenuItems>
                                </transition>
                            </Menu>
                            <a
                                v-else
                                :href="item.href"
                                :class="[item.current ? 'border-black text-black font-bold' : 'border-transparent text-black font-bold hover:border-gray-300 hover:text-black', 'inline-flex items-center px-1 pt-1 border-b-2 text-sm']"
                                :aria-current="item.current ? 'page' : undefined"
                            >
                                {{ item.name }}
                            </a>
                        </template>
                    </div>
                </div>
                <div class="hidden sm:ml-6 sm:flex sm:items-center">
                    <Menu v-if="notifications !== null && notifications.length > 0" as="div" class="relative">
                    <MenuButton
                        type="button"
                        class="relative rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        @click="onOpenNotifications"
                    >
                            <span class="absolute -inset-1.5" />
                            <span class="sr-only">View notifications</span>
                            <BellIcon class="h-6 w-6" aria-hidden="true" />

                            <span
                                v-if="unreadNotificationsCount > 0"
                                class="flex items-center justify-center absolute -top-1.5 -right-1.5 h-5 min-w-[1.25rem] bg-red-600 rounded-full text-white text-xs font-bold"
                            >
                                <span class="block whitespace-nowrap px-1">{{ unreadNotificationsCount }}</span>
                            </span>
                        </MenuButton>

                        <transition enter-active-class="transition ease-out duration-200" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                            <MenuItems class="origin-top-right absolute right-0 mt-2 w-72 z-50 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <MenuItem v-for="item in notifications" :key="item.id">
                                    <p class="group flex items-start px-4 py-2 text-sm text-black">
                                        <InformationCircleIcon
                                            class="mr-3 mt-2 h-5 w-5 flex-shrink-0"
                                            :class="item.read ? 'text-gray-600' : 'text-yellow-600'"
                                            aria-hidden="true"
                                        />
                                        {{ item.message }}
                                    </p>
                                </MenuItem>
                            </MenuItems>
                        </transition>
                    </Menu>
                    <div class="ml-4 flex items-center space-x-2 whitespace-nowrap">
                        <span class="text-base font-bold text-gray-900">Powered by</span>
                        <img src="https://theudderway.com/wp-content/uploads/2025/06/NEW-TUW-Logo_2@4x-scaled-e1749552451142.png" alt="Udderway" class="h-8 w-auto" />
                    </div>
                </div>
                <div class="-mr-2 flex items-center sm:hidden">
                    <!-- Mobile menu button -->
                    <DisclosureButton class="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        <span class="sr-only">Open main menu</span>
                        <MenuIcon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
                        <XIcon v-else class="block h-6 w-6" aria-hidden="true" />
                    </DisclosureButton>
                </div>
            </div>
        </div>

        <DisclosurePanel class="sm:hidden">
                <div class="pt-2 pb-3 space-y-1">
                    <template v-for="item in navigation" :key="item.name">
                        <div v-if="item.children && item.children.length" class="">
                            <div class="px-4 py-2 text-base font-bold text-black">{{ item.name }}</div>
                            <DisclosureButton v-for="child in item.children" :key="child.name" as="a" :href="child.href" :class="[child.current ? 'bg-indigo-50 border-black text-black font-bold' : 'border-transparent text-black font-bold hover:bg-gray-50 hover:border-gray-300 hover:text-black', 'block pl-6 pr-4 py-2 border-l-4 text-base']" :aria-current="child.current ? 'page' : undefined">
                                {{ child.name }}
                            </DisclosureButton>
                        </div>
                        <DisclosureButton
                            v-else
                            as="a"
                            :href="item.href"
                            :class="[item.current ? 'bg-indigo-50 border-black text-black font-bold' : 'border-transparent text-black font-bold hover:bg-gray-50 hover:border-gray-300 hover:text-black', 'block pl-3 pr-4 py-2 border-l-4 text-base']"
                            :aria-current="item.current ? 'page' : undefined"
                        >
                            {{ item.name }}
                        </DisclosureButton>
                    </template>
                </div>
            <div class="pt-4 pb-3 border-t border-gray-200">
                <div class="flex items-center px-4">
                    <div class="flex-shrink-0">
                        <span class="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
                            <span class="font-medium leading-none text-white">{{ initials }}</span>
                        </span>
                    </div>
                    <div class="ml-3">
                        <div class="text-base font-medium text-gray-800">{{ user.name }}</div>
                        <div class="text-sm font-medium text-gray-500">{{ user.email }}</div>
                    </div>
                </div>
                <div class="mt-3 space-y-1">
                    <DisclosureButton v-for="item in userNavigation" :key="item.name" as="a" :href="item.href" class="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100">
                        {{ item.name }}
                    </DisclosureButton>
                </div>
            </div>
        </DisclosurePanel>
    </Disclosure>
</template>


<script>
    import {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
    } from '@headlessui/vue';
    import {
        Bars3Icon as MenuIcon,
        XMarkIcon as XIcon,
        BellIcon,
        InformationCircleIcon,
    } from '@heroicons/vue/24/outline';
    import Axios from 'axios';

    const userNavigation = [
        { name: 'Your Profile', href: '/settings/profile/' },
        { name: 'Settings', href: '/settings/' },
        { name: 'Sign out', href: '/logout/' },
    ];

    export default {
        components: {
            Disclosure,
            DisclosureButton,
            DisclosurePanel,
            Menu,
            MenuButton,
            MenuItem,
            MenuItems,
            MenuIcon,
            BellIcon,
            InformationCircleIcon,
            XIcon,
        },

        inject: ['user', 'navigation', 'logo'],

        props: {
            notifications: {
                type: [Array, null],
                default: null,
            },
        },

        emits: ['clear-notifications'],

        setup() {
            return {
                userNavigation,
            };
        },

        computed: {
            initials() {
                return this.user.name.split(' ').map((n) => n[0]).join('').toUpperCase();
            },
            unreadNotificationsCount() {
                if (!this.notifications) {
                    return 0;
                }

                return this.notifications.filter((n) => !n.read).length;
            },
        },

        methods: {
            async onOpenNotifications() {
                await Axios.post('/notifications/clear/', {}, {
                    headers: {
                        // Add Django CSRF
                        'X-CSRFToken': document.querySelector('input[name="csrfmiddlewaretoken"]').value,
                    },
                });

                setTimeout(() => {
                    this.$emit('clear-notifications');
                }, 2000);
            },
        },
    };
</script>
